const extractError = (error) =>
  ((error.response || {}).data || {}).error_description ||
  ((error.response || {}).data || {}).error ||
  error.message;

export default extractError;
